module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images/hayley-barnett-781c49de7183167519e605bc66291bca.jpg";